"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTraitConfig = exports.getGenericConfigByType = exports.getConfigByType = void 0;
var Chevron_1 = __importDefault(require("Public/Widgets/Chevron"));
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var chevronStyles = __importStar(require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Chevron/ChevronWidget.css"));
var lodash_1 = require("lodash");
var Box_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Box"));
var makeConfig = function (config) { return config; };
var configs = [
    makeConfig({
        type: "chevron",
        tokenType: {},
        publicRender: function (_a) {
            var _b;
            var token = _a.token, attributes = _a.attributes;
            return server_1.default.renderToString(react_1.default.createElement(Chevron_1.default, { attributes: attributes, clickToScroll: (_b = token.clickToScroll) !== null && _b !== void 0 ? _b : true }));
        },
        traits: {
            styleable: {
                styleKey: "chevron",
                properties: [
                    { name: "backgroundColor", label: "Background color", type: "color", var: chevronStyles.backgroundColor },
                ],
            },
        },
    }),
    makeConfig({
        type: "box",
        tokenType: {},
        publicRender: function (_a) {
            var token = _a.token, renderTokens = _a.renderTokens;
            return server_1.default.renderToString(react_1.default.createElement(Box_1.default, {
                columns: [renderTokens(token.columns[0]), renderTokens(token.columns[1])],
            }));
        },
        flattenForComments: function (currentToken, flattenedTokens) {
            (0, lodash_1.flattenDeep)(currentToken.columns).forEach(function (t) { return flattenedTokens.push(t); });
        },
        tokenTraversers: {
            getFlatFromListOfTokens: function (token, runFlat) {
                var _a, _b, column, _c, _d, columnToken, e_1_1, e_2_1;
                var e_2, _e, e_1, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0: return [4, token];
                        case 1:
                            _g.sent();
                            _g.label = 2;
                        case 2:
                            _g.trys.push([2, 13, 14, 15]);
                            _a = __values(token.columns), _b = _a.next();
                            _g.label = 3;
                        case 3:
                            if (!!_b.done) return [3, 12];
                            column = _b.value;
                            _g.label = 4;
                        case 4:
                            _g.trys.push([4, 9, 10, 11]);
                            _c = (e_1 = void 0, __values(runFlat(column))), _d = _c.next();
                            _g.label = 5;
                        case 5:
                            if (!!_d.done) return [3, 8];
                            columnToken = _d.value;
                            return [4, columnToken];
                        case 6:
                            _g.sent();
                            _g.label = 7;
                        case 7:
                            _d = _c.next();
                            return [3, 5];
                        case 8: return [3, 11];
                        case 9:
                            e_1_1 = _g.sent();
                            e_1 = { error: e_1_1 };
                            return [3, 11];
                        case 10:
                            try {
                                if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                            return [7];
                        case 11:
                            _b = _a.next();
                            return [3, 3];
                        case 12: return [3, 15];
                        case 13:
                            e_2_1 = _g.sent();
                            e_2 = { error: e_2_1 };
                            return [3, 15];
                        case 14:
                            try {
                                if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7];
                        case 15: return [2];
                    }
                });
            },
            getTransformedTokens: function (token, aggregateTokens, unpackAndTransformFn, transformFn) {
                var transformedColumns = [unpackAndTransformFn(token.columns[0]), unpackAndTransformFn(token.columns[1])];
                token.columns = transformedColumns;
                return __spreadArray(__spreadArray([], __read(aggregateTokens), false), __read(transformFn(token)), false);
            },
        },
        traits: {},
    }),
];
var getConfigByType = function (type) {
    var e_3, _a;
    try {
        for (var configs_1 = __values(configs), configs_1_1 = configs_1.next(); !configs_1_1.done; configs_1_1 = configs_1.next()) {
            var config = configs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (configs_1_1 && !configs_1_1.done && (_a = configs_1.return)) _a.call(configs_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    throw new Error("Config with type ".concat(type, " not registered"));
};
exports.getConfigByType = getConfigByType;
var getGenericConfigByType = function (type) {
    try {
        return (0, exports.getConfigByType)(type);
    }
    catch (_a) {
        return undefined;
    }
};
exports.getGenericConfigByType = getGenericConfigByType;
var getTraitConfig = function (_a) {
    var widgetType = _a.widgetType, traitName = _a.traitName;
    return (0, exports.getConfigByType)(widgetType).traits[traitName];
};
exports.getTraitConfig = getTraitConfig;
